<template>
  <div>
    <b-card-body >
      <b-card class="card-body-container">
        <div class="title-container">
          <p>
            A variável <b>{{ name }}</b> não pode ser excluída porque consta em:
          </p>
        </div>
        <div class="result-container">
          <div class="result-area">
            <div class="itens-container" v-for="(item, key) in result" :key="key">
              <span><b>- {{ item.name }}</b></span>
              <li v-for="variable in item.list" :key="variable">
                <span>{{ variable }}</span>
              </li>
            </div>
          </div>

          <div class="groupBtn">
            <img
              id="closeModalPassword"
              class="float-right"
              src="@/assets/sair.png"
              style="margin-left: 30px"
              :title="$t('cancelar')"
              alt="cancelar"
              @click="$bvModal.hide('modalEraseVariable')"
            />
          </div>

        </div>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
export default {
  name: "EraseVariable",
  props: {
    result: Object /* { key1: { name: string, list: Array[Object] }, key2: ... } */,
    name: String,
  },
  data: function () {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style scoped>
.result-container {
  max-width: 800px;
  min-height: 350px;
  max-height: 500px;
  display: grid;
  grid-template-rows: auto 40px;
}

.result-area {
  max-height: 400px;
  overflow: auto;
  margin-bottom: 25px;
}

li {
  margin-left: 32px;
}

.title-container p {
  font-weight: 700;
  font-size: 1.2rem;
}

.itens-container span {
  font-weight: 600;
  font-size: 1.1rem;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.groupBtn img {
  max-height: 35px;
  cursor: pointer;
}

@media (max-width: 990px) {
  .title-container p {
    font-size: 1.05rem;
  }

  .itens-container span {
    font-size: 1rem;
  }
}

@media (max-width: 360px) {
  .title-container p {
    font-size: 0.95rem;
  }

  .itens-container span {
    font-size: 0.92rem;
  }

  .itens-container li span {
    font-size: 0.85rem;
  }
}
</style>
